module.exports = __webpack_public_path__ + "static/media/pole-number-example-2.b8c357c4.png";